/*
  Wishlist core (no app) — stores product handles in localStorage.
  Exposes window.OFWishlist and keeps every [data-wishlist-toggle] button
  and [data-wishlist-count] badge in sync across the page and other tabs.
*/
(function () {
  if (window.OFWishlist) return;

  var KEY = 'of_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  }

  var api = {
    all: read,
    count: function () { return read().length; },
    has: function (h) { return read().indexOf(h) !== -1; },
    add: function (h) { var l = read(); if (l.indexOf(h) === -1) { l.unshift(h); write(l); } },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    toggle: function (h) { api.has(h) ? api.remove(h) : api.add(h); return api.has(h); },
    clear: function () { write([]); }
  };
  window.OFWishlist = api;

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) !== -1;
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', on);
      btn.classList.toggle('is-active', on);
      var lbl = btn.querySelector('[data-wishlist-label]');
      var text = on ? btn.dataset.labelOn : btn.dataset.labelOff;
      if (lbl && text && lbl.textContent !== text) lbl.textContent = text;
      var aria = on ? btn.dataset.ariaOn : btn.dataset.ariaOff;
      if (aria && btn.getAttribute('aria-label') !== aria) btn.setAttribute('aria-label', aria);
    });
    var n = String(list.length);
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== n) el.textContent = n;
      if (el.hasAttribute('data-hide-empty')) el.hidden = list.length === 0;
    });
  }

  // Capture phase so the heart works even inside a product-card link
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = api.toggle(btn.dataset.handle);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (on) btn.classList.add('is-pop');
  }, true);

  document.addEventListener('wishlist:change', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  // Re-sync when the theme injects new cards (filters, infinite scroll, quick view)
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
